'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { TradeSettingsDialog } from '@/components/trade/trade-settings-dialog';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/app-tabs';
import { checkGate } from '@/lib/analytics';
interface ProposalFormDirectionTabsProps {
  direction: 'fund' | 'withdraw';
  disabled: boolean;
  onDirectionChange: (direction: 'fund' | 'withdraw') => void;
}
export function ProposalFormDirectionTabs(t0) {
  const $ = _c(23);
  const {
    direction,
    disabled,
    onDirectionChange
  } = t0;
  const t = useTranslations("launchpad.detail");
  const tWithdraw = useTranslations("launchpad.withdraw");
  let t1;
  if ($[0] !== disabled || $[1] !== onDirectionChange) {
    t1 = function changeDirection(value) {
      if (disabled || value !== "fund" && value !== "withdraw") {
        return;
      }
      setTimeout(() => onDirectionChange(value), 0);
    };
    $[0] = disabled;
    $[1] = onDirectionChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const changeDirection = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("backCta");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== disabled || $[6] !== t2) {
    t3 = <TabsTrigger value="fund" disabled={disabled}>{t2}</TabsTrigger>;
    $[5] = disabled;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== tWithdraw) {
    t4 = tWithdraw("title");
    $[8] = tWithdraw;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== disabled || $[11] !== t4) {
    t5 = <TabsTrigger value="withdraw" disabled={disabled}>{t4}</TabsTrigger>;
    $[10] = disabled;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <TabsList variant="segmented" size="md">{t3}{t5}</TabsList>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== changeDirection || $[17] !== direction || $[18] !== t6) {
    t7 = <Tabs className="min-w-0 flex-1" value={direction} onValueChange={changeDirection}>{t6}</Tabs>;
    $[16] = changeDirection;
    $[17] = direction;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = checkGate("trade_settings") ? <TradeSettingsDialog /> : null;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7) {
    t9 = <div className="flex w-full items-center gap-2">{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}